exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-update-restore .description-block {\n  padding-bottom: 20px; }\n\n.form-update-restore .form-block {\n  margin-top: 0px; }\n\n.form-update-restore .date-picker {\n  cursor: pointer; }\n\n.form-update-restore .picker-place-holder {\n  visibility: hidden; }\n\n.form-update-restore .date-picker-holder {\n  position: relative;\n  left: -50px;\n  top: -5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/update-restore/update-restore.scss
// module id = SVvj
// module chunks = 0